import React from "react"
import { Container, Row, Col } from "reactstrap"
import { Link } from "gatsby"

// Icons
import icon1 from "../../images/icons/software.png"
import icon2 from "../../images/icons/erp.png"
import icon3 from "../../images/icons/infra.png"
import icon4 from "../../images/icons/contact.png"
import icon5 from "../../images/icons/sales.png"
import icon6 from "../../images/icons/security.png"
import icon7 from "../../images/icons/oracle.svg"
import icon8 from "../../images/icons/other.png"
import icon9 from "../../images/icons/data.png"
const Area = () => {
  return (
    <div id="area-oa" className="py-100">
      <Container>
        <h3 className="text-center text-white mb-5 text-uppercase position-relative">
          AREAS OF EXPERTISE
        </h3>
        <Row className="justify-content-center">
          {/* <Col md={4} sm={6} className="mb-5">
            <div className="h-100">
              <div className="bg-fff">
                <img src={icon1} className="img-fluid" alt="Expertise" />
                <h6>SOFTWARE</h6>
              </div>
              <div className="bg-white">
                <p>
                  Java Developers, .NET Developers, Python Developers, Angular
                  Developers, React Developers, Front-End Developers, UX
                  Designers, SharePoint Developers, iOS Developers, Android
                  Developers, Xamarin Developers, Firmware Engineers, QA
                  Testers, QA Engineers, Product Managers, Product Owners.
                </p>
              </div>
            </div>
          </Col> */}
          <Col md={6} sm={12} className="mb-5">
            <Link className="" to="../technology/ERPCRM">
              <div className="h-100">
                <div className="bg-fff">
                  <img src={icon2} className="img-fluid" alt="Expertise" />
                  <h6>ERP + CRM</h6>
                </div>
                <div className="bg-white">
                  <p>
                    Seeking Enterprise Resource Planning and Customer
                    Relationship Management talent? Look no further. PeerSource
                    recruits talented ERP and CRM experts with expertise
                    spanning Oracle, Microsoft, NetSuite, Workday, SAP, Infor,
                    and Salesforce:
                  </p>
                  <div className="row">
                    <div className="col-md-6">
                      <ul className="checked-list lead text-left">
                        <li>Functional Consultants</li>
                        <li>Technical Consultants</li>
                        <li>Implementation Consultants</li>
                        <li>Project Managers</li>
                        <li>System Analysts</li>
                        <li>ERP Administrators</li>
                      </ul>
                    </div>
                    <div className="col-md-6 mb-5">
                      <ul className="checked-list lead text-left">
                        <li>CRM Administrators</li>
                        <li>Customer Success Managers</li>
                        <li>Sales Engineers</li>
                        <li>Executive Leadership</li>
                        <li>And more!</li>
                      </ul>
                    </div>
                    <div className="text-center">
                      <Link to="/technology/ERPCRM">
                        <button className="common-btn">Learn More</button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>{" "}
            </Link>
          </Col>
          <Col md={6} sm={12} className="mb-5">
            <Link className="" to="../technology/data">
              <div className="h-100">
                <div className="bg-fff">
                  <img src={icon9} className="img-fluid" alt="Expertise" />
                  <h6>DATA</h6>
                </div>
                <div className="bg-white">
                  <p>
                    Source highly skilled and experienced data technology
                    experts for your next project. We staff & recruit a wide
                    variety of professionals, including:
                  </p>
                  <div className="row" style={{ marginTop: "2.5rem" }}>
                    <div className="col-md-6">
                      <ul className="checked-list lead text-left">
                        <li>Database Administrators</li>
                        <li>Data Analysts</li>
                        <li>Data Engineers</li>
                        <li>BI Developers</li>
                        <li>ETL Developers</li>
                      </ul>
                    </div>
                    <div className="col-md-6">
                      <ul className="checked-list lead text-left">
                        <li>Data Architects</li>
                        <li>Data Scientists</li>
                        <li>AI/ML Engineers</li>
                        <li>Executive Leadership</li>
                        <li>And more!</li>
                      </ul>
                    </div>
                    <div className="text-center">
                      <Link to="/technology/data">
                        <button className="common-btn">Learn More</button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </Col>
          {/* <Col md={4} sm={6} className="mb-5">
            <div className="h-100">
              <div className="bg-fff">
                <img src={icon3} className="img-fluid" alt="Expertise" />
                <h6>INFRASTRUCTURE</h6>
              </div>
              <div className="bg-white">
                <p>
                  Help Desk Specialists, Desktop Support Analysts, Application
                  Support Specialists, Network Administrators, NOC
                  Administrators, Network Engineers, System Administrators,
                  System Engineers, Middleware Engineers, Telecom Engineers,
                  DevOps Engineers, Automation Engineers, Cloud Engineers.
                </p>
              </div>
            </div>
          </Col>
          <Col md={4} sm={6} className="mb-5">
            <div className="h-100">
              <div className="bg-fff">
                <img src={icon6} className="img-fluid" alt="Expertise" />
                <h6>SECURITY</h6>
              </div>
              <div className="bg-white">
                <p>
                  Security Analysts, Security Engineers, Network Security
                  Engineers, Application Security Engineer, IAM Engineers,
                  Security Architects, Penetration Testers, Vulnerability
                  Analysts, SOC Analysts, GRC Analysts, Compliance Analysts, IT
                  Auditors.
                </p>
              </div>
            </div>
          </Col>
          <Col md={4} sm={6} className="mb-5">
            <div className="h-100">
              <div className="bg-fff">
                <img src={icon4} className="img-fluid" alt="Expertise" />
                <h6>PROJECT/PROGRAM MANAGER</h6>
              </div>
              <div className="bg-white">
                <p>
                  Agile Scrum Masters, Application Project Managers,
                  Infrastructure Project Managers, ERP Project Managers, M&A
                  Project Managers, M&A Consultants.
                </p>
              </div>
            </div>
          </Col>
          <Col md={4} sm={6} className="mb-5">
            <div className="h-100">
              <div className="bg-fff">
                <img src={icon5} className="img-fluid" alt="Expertise" />
                <h6>SALES</h6>
              </div>
              <div className="bg-white">
                <p>
                  Sales Operations Analysts, Customer Success Managers, Inside
                  Sales Representatives, Account Executives, Pre-sales
                  Engineers, Sales Managers.
                </p>
              </div>
            </div>
          </Col>
          <Col md={4} sm={6} className="mb-5">
            <div className="h-100">
              <div className="bg-fff">
                <img src={icon7} className="img-fluid" alt="Expertise" />
                <h6>ORACLE</h6>
              </div>
              <div className="bg-white">
                <p>
                  Sales Operations Analysts, Customer Success Managers, Inside
                  Sales Representatives, Account Executives, Pre-sales
                  Engineers, Sales Managers.
                </p>
              </div>
            </div>
          </Col>
          <Col md={4} sm={6} className="mb-5">
            <div className="h-100">
              <div className="bg-fff">
                <img src={icon8} className="img-fluid" alt="Expertise" />
                <h6>OTHER</h6>
              </div>
              <div className="bg-white">
                <p>
                  Business Analysts, Systems Analysts, Technical Writers,
                  Solution Architects, Enterprise Architects, EHR/EMR
                  Consultants, Financial Analysts, Accountants, Tax Accountants,
                  Auditors, Accounting Managers, Controllers, Recruiters, HR
                  Generalists, Digital Marketing Specialists, Directors, VPs,
                  C-Level.
                </p>
              </div>
            </div>
          </Col> */}
          <Col sm={12}>
            <div className="relative text-center">
              <Link className="white-btn block" to="../contact-us">
                Contact PeerSource
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Area
